const initialState = null;

export default function organisationLogo(state = initialState, action = '') {
  if (action.type === 'setOrganisationLogo') {
    return action.organisationLogo;
  }

  return state;
}
